module.exports = __webpack_public_path__ + "img/simplisite.5f77e022.jpg";